<template>
  <div
    v-if="barData"
    class="cm-horizontal-bar-card"
  >
    <CmGrid
      :width="656"
      :cellSize="50"
      :top="10"
      :left="152"
    />
    <table>
      <tr
        v-for="(item, index) in barData"
        :key="index"
        class="cm-horizontal-bar-card__item-container"
      >
        <td class="cm-horizontal-bar-card__label">
          {{ item.title }}
        </td>
        <td class="cm-horizontal-bar-card__bar-container">
          <span
            v-if="!item.hidePercent"
            class="cm-horizontal-bar-card__bar"
            :style="item.style"
          ></span>
          <span>{{ fNum.format(item.count) }}</span>
          <span v-if="!item.hidePercent">
            {{ item.percent }}%
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import CmGrid from "@/components/library/additional/CmGrid.vue";
import { scaleLinear } from "d3";

export default {
  name: "CmBarCard",

  components: {
    CmGrid
  },

  props: {
    value: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      barData: null
    }
  },

  mounted() {
    this.formBarData();
  },

  methods: {
    formBarData() {
      const scale = scaleLinear()
        .range([0, 100])
        .domain([0, this.value[0].count || 1]);

      this.barData = this.value.map(i => {
        return {
          ...i,
          percent: Math.floor(scale(i.count)),
          style: {
            backgroundColor: i.color || "#00AEDF",
            width: scale(i.count) * 5 + "px"
          }
        }
      });
    }
  }
}
</script>

<style lang="scss">
.cm-horizontal-bar-card {
  overflow-x: auto;
  padding: 0px 0;
  max-width: 973px;
  position: relative;
  z-index: 2;

  .cm-grid {
    height: 186px;
  }

  &__item-container {
    td {
      color: $color_black_new;
      font-size: 11px;
      white-space: nowrap;
      padding: 10px 8px;
    }
  }
  &__bar-container {
    display: flex;
    width: 80%;
    padding-right: 35px;
    span {
      margin-right: 10px;
      &:only-of-type {
        margin-left: 5px;
      }
    }
  }
  &__bar {
    border-radius: 0px 4px 4px 0px;
    height: 20px;
  }
  &__label {
    text-align: right;
    width: 120px;
  }
}
</style>
